export enum RoleEnum {
    ADMIN,
    WAITER
}
